var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcJammer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.19 255.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#82042e;}.cls-2{fill:#7e0100;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-Jammer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_9",
    "data-name": 9
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icono"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.5,255.12H26.16c-8.33,0-14.85-2.3-19.36-6.84S0,237.2,0,228.84V105.94C0,90.42,6.6,82.36,22.06,79l.64-.14,121.7,0,.42.06c9.07,1.28,15.53,5.23,19.2,11.73,2.92,5.16,4,11.81,3.21,20.31,0,5.63.1,91.13.09,117.42,0,17.47-9.29,26.7-26.87,26.71H78.5ZM24,91.13c-9.44,2.15-11.77,5.16-11.77,14.81v3.84q0,59.54,0,119.06c0,10.09,3.9,14,13.91,14H140.45c10.93,0,14.62-3.65,14.62-14.45h0c0-27-.1-116.79-.1-117.69v-.29l0-.29c1.32-14-3.39-17.76-11.48-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.63,154.37a8.78,8.78,0,0,1-.28-17.55,9,9,0,0,1,8.6,8.36A8.9,8.9,0,0,1,135.63,154.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144,119.07a8.6,8.6,0,1,1-17.2.24,8.6,8.6,0,0,1,17.2-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.11,91.26A6.14,6.14,0,0,1,24,85.13v-79a6.13,6.13,0,0,1,12.26,0v79A6.14,6.14,0,0,1,30.11,91.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.19,91.13A6.13,6.13,0,0,1,61.06,85V22.61a6.13,6.13,0,1,1,12.25,0V85A6.13,6.13,0,0,1,67.19,91.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,91.13A6.13,6.13,0,0,1,94.84,85V22.61a6.13,6.13,0,1,1,12.25,0V85A6.13,6.13,0,0,1,101,91.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36,91.13A6.13,6.13,0,0,1,129.23,85V22.61a6.13,6.13,0,1,1,12.26,0V85A6.14,6.14,0,0,1,135.36,91.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,159.82c-.27-3.68-.06-41.1,0-48.56l12.25.07c-.1,17.06-.2,45.07,0,47.6Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcJammer);
export default __webpack_public_path__ + "static/media/ic-Jammer.507d8de6e0f5b685f9378044202e5782.svg";
export { ForwardRef as ReactComponent };